import { LocalStorageKeys } from '../constants/local-storage-keys'
import User from '../types/api/user'

export class UserStorage {
    private readonly key = LocalStorageKeys.User

    set(user: User) {
        localStorage.setItem(this.key, JSON.stringify(user))
    }

    get() {
        const user = localStorage[this.key]

        if (!user) {
            return undefined
        }

        return JSON.parse(user) as User
    }

    remove() {
        localStorage.removeItem(this.key)
    }
}
